import { render, staticRenderFns } from "./ocr.vue?vue&type=template&id=a112f8c6&scoped=true"
import script from "./ocr.vue?vue&type=script&lang=js"
export * from "./ocr.vue?vue&type=script&lang=js"
import style0 from "./ocr.vue?vue&type=style&index=0&id=a112f8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a112f8c6",
  null
  
)

export default component.exports